import { Grid } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { observer } from 'mobx-react';
import React from 'react';
import { configOptionLabels } from '../../../cli/src/config-generator';
export var ConfiguratorForm = observer(function (_a) {
    var store = _a.store;
    return (React.createElement(Grid, { container: true }, Object.keys(configOptionLabels).map(function (fieldName) { return (React.createElement(Grid, { item: true, xs: 12, sm: 6, key: fieldName },
        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: store[fieldName], onChange: function () { return (store[fieldName] = !store[fieldName]); } }), label: configOptionLabels[fieldName] }))); })));
});
